import * as React from 'react';
import 'twin.macro';
import 'styled-components/macro';
import useResizeObserver from 'use-resize-observer';

export interface ResponsiveFrameProps {
  aspectRatio: number;
  children?: React.ReactNode;
  innerRef?: React.Ref<HTMLDivElement>;
}

export const ResponsiveFrame = ({ aspectRatio, children, innerRef }: ResponsiveFrameProps) => {
  const { height: outerHeight = 0, ref: outerRef, width: outerWidth = 0 } = useResizeObserver();

  let width = outerWidth;
  let height = width / aspectRatio;

  if (height > outerHeight) {
    width = outerHeight * aspectRatio;
    height = outerHeight;
  }

  return (
    <div ref={outerRef} tw="border-1 border-transparent flex h-full items-center justify-center p-3">
      <div
        ref={innerRef}
        tw="border-1 border-white border-opacity-10 box-content -m-3 p-3 rounded-xs"
        style={{ height, width }}
      >
        {children}
      </div>
    </div>
  );
};
